import { UserDto } from '@/services/platform/api/model';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  isAuthenticated: boolean;
  isWelcomed: boolean;
  hasPermissions: boolean;
  user: UserDto | null;
  pin: number | null;
  isBiometricEnabled: boolean;
  accessToken: string | null;
  refreshToken: string | null;
  expiresAt: string | null;
  isSessionActive: boolean;
  setUser: (user: UserDto | null) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  setHasPermissions: (hasPermissions: boolean) => void;
  setIsWelcomed: (isWelcomed: boolean) => void;
  setTokens: (accessToken: string, refreshToken: string | null, expiresAt: string | null) => void;
  setPin: (pin: number | null) => void;
  setIsBiometricEnabled: (value: boolean) => void;
  setIsSessionActive: (value: boolean) => void;
  clearUser: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      isAuthenticated: false,
      isWelcomed: false,
      hasPermissions: false,
      user: null,
      accessToken: null,
      refreshToken: null,
      expiresAt: null,
      pin: null,
      isBiometricEnabled: false,
      isSessionActive: sessionStorage.getItem('session-active') === '1',
      setUser: user => set({ user, isAuthenticated: !!user }),
      setIsAuthenticated: (isAuthenticated: boolean) => set({ isAuthenticated }),
      setHasPermissions: (hasPermissions: boolean) => set({ hasPermissions }),
      setIsWelcomed: (isWelcomed: boolean) => set({ isWelcomed }),
      setTokens: (accessToken, refreshToken, expiresAt) => set({ accessToken, refreshToken, expiresAt }),
      setPin: (pin: number | null) => set({ pin }),
      setIsBiometricEnabled: (value: boolean) => set({ isBiometricEnabled: value }),
      setIsSessionActive: (value: boolean) => set({ isSessionActive: value }),
      clearUser: () =>
        set({
          user: null,
          isAuthenticated: false,
          accessToken: null,
          refreshToken: null,
          expiresAt: null,
          isWelcomed: false,
          hasPermissions: false,
          pin: null,
        }),
    }),
    {
      name: 'auth-storage',
      partialize: state => ({
        isAuthenticated: state.isAuthenticated,
        isWelcomed: state.isWelcomed,
        hasPermissions: state.hasPermissions,
        user: state.user,
        pin: state.pin,
        isBiometricEnabled: state.isBiometricEnabled,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        expiresAt: state.expiresAt,
      }),
    }
  )
);
